import axios from 'axios'
import { Message } from 'element-ui'
import { GLOBAL_CONFIG } from '@/config/global'

// 创建 axios 实例
const request = axios.create({
  baseURL: GLOBAL_CONFIG.BASE_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

// 请求拦截器 - 添加全局参数
request.interceptors.request.use(
  config => {
    // 添加 token（登录成功后才有）
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }

    // 获取时间戳和签名
    const timestamp = GLOBAL_CONFIG.getTimestamp()
    const sign = GLOBAL_CONFIG.generateSign()

    console.log('=== 请求参数 ===')
    console.log('api_channel_no:', GLOBAL_CONFIG.API_CHANNEL_NO)
    console.log('timestamp:', timestamp)
    console.log('sign:', sign)
    console.log('完整URL:', config.baseURL + config.url)

    // 添加全局参数到请求中
    if (config.method === 'post' || config.method === 'put') {
      // POST 请求添加到 body
      if (config.data instanceof URLSearchParams) {
        config.data.append('api_channel_no', GLOBAL_CONFIG.API_CHANNEL_NO)
        config.data.append('timestamp', timestamp)
        config.data.append('sign', sign)
      } else if (config.data instanceof FormData) {
        config.data.append('api_channel_no', GLOBAL_CONFIG.API_CHANNEL_NO)
        config.data.append('timestamp', timestamp)
        config.data.append('sign', sign)
      } else {
        config.data = {
          ...config.data,
          api_channel_no: GLOBAL_CONFIG.API_CHANNEL_NO,
          timestamp: timestamp,
          sign: sign
        }
      }
    } else if (config.method === 'get') {
      // GET 请求添加到 params
      config.params = {
        ...config.params,
        api_channel_no: GLOBAL_CONFIG.API_CHANNEL_NO,
        timestamp: timestamp,
        sign: sign
      }
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    const res = response.data

    console.log('=== 响应数据 ===')
    console.log(res)

    if (res.code === 200) {
      return res
    } else if (res.code === 400) {
      Message.error(res.msg || '缺少必要参数或签名验证失败')
      return Promise.reject(res)
    } else if (res.code === 401) {
      Message.error(res.msg || '用户名或密码错误')
      localStorage.removeItem('token')
      localStorage.removeItem('username')
      window.location.href = '/login'
      return Promise.reject(res)
    } else if (res.code === 402) {
      Message.error(res.msg || '请求令牌已过期')
      localStorage.removeItem('token')
      localStorage.removeItem('username')
      window.location.href = '/login'
      return Promise.reject(res)
    } else if (res.code === 403) {
      Message.error(res.msg || '无权限访问该接口')
      return Promise.reject(res)
    } else if (res.code === 500) {
      Message.error(res.msg || '系统配置错误')
      return Promise.reject(res)
    } else {
      Message.error(res.msg || '请求失败')
      return Promise.reject(res)
    }
  },
  error => {
    console.error('请求错误:', error)
    Message.error('网络请求失败，请稍后重试')
    return Promise.reject(error)
  }
)

// 登录接口
export function Index() {
   const params = new URLSearchParams()
  return request({
    url: 'index/index',
    method: 'post',
    data: params  // ✅ 必须传 data
  })
}
// 添加留言接口
export function addMessage(data) {
  const params = new URLSearchParams()
  params.append('company', data.company)
  params.append('phone', data.phone)
  params.append('content', data.content)
  
  return request({
    url: '/index/addMsg',
    method: 'post',
    data: params
  })
}
 

// 添加留言接口
export function Navs(data) {
  const params = new URLSearchParams()
   
  
  return request({
    url: '/index/nav',
    method: 'post',
    data: params
  })
}
 




export default request


// WEBPACK FOOTER //
// ./src/api/login.js